import { render, staticRenderFns } from "./BillboardConifg.vue?vue&type=template&id=291e5ab2&scoped=true&"
import script from "./BillboardConifg.vue?vue&type=script&lang=js&"
export * from "./BillboardConifg.vue?vue&type=script&lang=js&"
import style0 from "./BillboardConifg.vue?vue&type=style&index=0&id=291e5ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291e5ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('291e5ab2')) {
      api.createRecord('291e5ab2', component.options)
    } else {
      api.reload('291e5ab2', component.options)
    }
    module.hot.accept("./BillboardConifg.vue?vue&type=template&id=291e5ab2&scoped=true&", function () {
      api.rerender('291e5ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/BillboardConifg.vue"
export default component.exports